const DOCUMENT = 'DEMO_USER_';

const actions = {
  ADD: DOCUMENT + 'ADD',
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  DELETE: DOCUMENT + 'DELETE',
  DELETE_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',
  EDIT: DOCUMENT + 'EDIT',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',

  add: data => ({ type: actions.ADD, payload: data }),

  cancel: () => ({ type: actions.CANCEL }),

  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),

  create: () => ({ type: actions.CREATE }),

  delete: data => ({ type: actions.DELETE, payload: data }),

  deleteSuccess: () => ({ type: actions.DELETE_SUCCESS }),

  edit: data => ({ type: actions.EDIT, payload: data }),

  loadData: data => ({ type: actions.LOAD, payload: data }),

  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),

  loadFormData: data => ({ type: actions.LOAD_FORM_DATA, payload: data }),

  save: data => ({ type: actions.SAVE, payload: data }),

  saveError: data => ({ type: actions.SAVE_ERROR, payload: data }),

  saveSuccess: data => ({ type: actions.SAVE_SUCCESS, payload: data }),

  touch: data => ({ type: actions.TOUCH, payload: data }),
};

export default actions;
